import styled from "styled-components";

export const Container = styled.button`
    align-items: center;
    background: #F6F6F6;
    border: none;
    border-radius: 5px;
    box-shadow: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 5px;
    height: 38px;
    justify-content: space-between;
    margin-block: 2.5px;
    outline: none;
    padding: 9px 7px;
    user-select: none;
    width: 100%;

    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;

export const ContainerType = styled.div`
    align-items: center;
    display: flex;
    gap: 6px;
    justify-content: center;
    width: 55%;
`

export const StateIndicator = styled.div`
    background: ${({ $background }) => $background ? $background : '#33CC99'};
    border-radius: 50%;
    height: 15px;
    width: 15px;
`;

export const Type = styled.h1`
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`;

export const NameContainer = styled.span`
    background: ${({ $background }) => $background ? $background : '#33CC99'};
    border-radius: 5px;
    color: #FFF;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    overflow: hidden;
    padding-block: 5px;
    padding-inline: 12px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 40%;
`;